import React from 'react';
import { Mail, Instagram, Facebook } from 'lucide-react';
export function Footer() {
  return <footer className="bg-dark border-t border-dark-border py-12 px-4" data-id="element-134">
      <div className="max-w-6xl mx-auto flex flex-col items-center text-center" data-id="element-135">
        <div className="flex items-center gap-3 mb-6" data-id="element-136">
          <span className="text-3xl" data-id="element-137">🧠</span>
          <h2 className="text-xl md:text-2xl font-heading font-bold text-white tracking-wider" data-id="element-138">
            ACADEMIA HOLÍSTICA ARGENTINA
          </h2>
        </div>

        <p className="text-gray-400 max-w-2xl mb-4" data-id="element-139">
          El sistema de transformación personal con PNL aplicada al contexto
          argentino.
        </p>
        <p className="text-gray-500 max-w-2xl mb-12 italic" data-id="element-140">
          Porque tu soberanía personal no debería postergarse por falta de un
          sistema a la altura de lo que sos capaz.
        </p>

        <div className="flex flex-col md:flex-row gap-6 md:gap-12 mb-12 text-gray-400" data-id="element-141">
          <a href="#" className="flex items-center gap-2 hover:text-gold transition-colors" data-id="element-142">
            <Mail className="w-5 h-5" data-id="element-143" />
            <span data-id="element-144">academiaholisticaargentina@gmail.com</span>
          </a>
          <a href="#" className="flex items-center gap-2 hover:text-gold transition-colors" data-id="element-145">
            <Instagram className="w-5 h-5" data-id="element-146" />
            <span data-id="element-147">@academiaholisticaargentina</span>
          </a>
          <a href="#" className="flex items-center gap-2 hover:text-gold transition-colors" data-id="element-148">
            <Facebook className="w-5 h-5" data-id="element-149" />
            <span data-id="element-150">Academia Holística Argentina</span>
          </a>
        </div>

        <div className="w-full border-t border-dark-border/50 pt-8 flex flex-col items-center gap-4" data-id="element-151">
          <p className="text-sm text-gray-600" data-id="element-152">
            © Academia Holística Argentina 2026 Todos los derechos reservados.
            Prohibida la reproducción y redistribución sin autorización expresa.
          </p>
          <p className="text-sm text-gold-dark font-heading italic" data-id="element-153">
            🧠 "El único contexto que realmente podés cambiar es el que tenés
            adentro."
          </p>
        </div>
      </div>
    </footer>;
}